import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class TenantSuiteNotFoundError extends CodedError {
  static get errorName() {
    return errorCodeTypes.tenantSuiteNotFoundError.code;
  }

  constructor(message = errorCodeTypes.tenantSuiteNotFoundError.message) {
    super(message);
    this.code = errorCodeTypes.tenantSuiteNotFoundError.code;
    this.message = `${message} ${errorCodeTypes.tenantSuiteNotFoundError.code}`;
    this.name = errorCodeTypes.tenantSuiteNotFoundError.name;
  }
}
